const CalendarRounded = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='66.981'
    height='73.648'
    viewBox='0 0 66.981 73.648'
    fill='#0e77ef'
    {...props}
  >
    <path
      id='calendar'
      d='M56.942,6.667H50.2V3.373A3.338,3.338,0,0,0,49.295.9,3.233,3.233,0,0,0,46.9,0a3.338,3.338,0,0,0-2.471.9,3.338,3.338,0,0,0-.9,2.471V6.667H23.451V3.373A3.338,3.338,0,0,0,22.549.9,3.338,3.338,0,0,0,20.079,0a3.233,3.233,0,0,0-2.392.9,3.338,3.338,0,0,0-.9,2.471V6.667H10.039A9.7,9.7,0,0,0,2.9,9.569,9.7,9.7,0,0,0,0,16.706v46.9a9.7,9.7,0,0,0,2.9,7.137,9.7,9.7,0,0,0,7.137,2.9h46.9A9.911,9.911,0,0,0,66.981,63.608v-46.9A9.911,9.911,0,0,0,56.942,6.667Zm-46.9,6.745h6.745v3.294a3.338,3.338,0,0,0,.9,2.471,3.233,3.233,0,0,0,2.392.9,3.118,3.118,0,0,0,3.373-3.373V13.412H43.53v3.294A3.118,3.118,0,0,0,46.9,20.079a3.233,3.233,0,0,0,2.392-.9,3.338,3.338,0,0,0,.9-2.471V13.412h6.745a3.1,3.1,0,0,1,3.294,3.294V26.745H6.745V16.706a3.1,3.1,0,0,1,3.294-3.294ZM56.942,66.9h-46.9a3.1,3.1,0,0,1-3.294-3.294V33.49H60.236V63.608A3.1,3.1,0,0,1,56.942,66.9Z'
    />
  </svg>
)

export default CalendarRounded
